<template>
  <ConfirmModal
    :text="
      $t(
        '_web_match-scheduling_modal-title',
        'Update schedule of the match, all further matches will be rescheduled if needed.'
      )
    "
    :confirm-button-text="$t('_web_save-label', 'Save')"
    :confirm-button-disabled="!canChangeMatchDate && !canChangeMatchDuration"
    :is-loading="isLoading"
    class="match-scheduling-modal"
    @cancel="closeModal"
    @confirm="onSave"
  >
    <div class="d-flex flex-row justify-content-center align-items-center mt-6">
      <DateTimePicker
        id="match-schedule-datetime"
        v-model="dateStart"
        :disabled="!canChangeMatchDate"
        class="cursor-pointer"
        :placeholder="
          $t('_web_tournament_match-date-placeholder', 'Select Date')
        "
      >
        <Icon
          slot="prepend-date"
          name="calendar"
          width="18"
          :fill="$scss.heraMuted"
          class="h-mr-3"
        />
        <div slot="prepend-time" class="h-mr-3"></div>
        <template #addon>
          <TextBlock
            :variant="[canChangeMatchDuration ? 'secondary' : 'muted']"
            :line-height="1"
            class="mx-3"
            >&ndash;</TextBlock
          >
          <TimePicker
            v-model="dateEnd"
            :disabled="!canChangeMatchDuration"
            placeholder="HH:mm"
            class="date-time-wrapper__time-input"
          />
        </template>
      </DateTimePicker>
    </div>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/components/modal/children/HeraConfirm';
import DateTimePicker from '@/components/form/DateTimePicker';
import TextBlock from '@/components/atoms/TextBlock';
import TimePicker from '@/components/form/TimePicker';
import Icon from '@/components/atoms/Icon';

import loadingHelper from '@/mixins/isLoading';

import { mapActions } from 'vuex';
import { prop } from '@/utils/factories';

export default {
  name: 'MatchSchedulingModal',
  components: {
    ConfirmModal,
    DateTimePicker,
    TextBlock,
    TimePicker,
    Icon,
  },
  mixins: [loadingHelper],
  props: {
    match: prop(Object),
    minDate: prop(Number),
    maxDate: prop(Number),
    canChangeMatchDate: prop(Boolean),
    canChangeMatchDuration: prop(Boolean),
  },
  data() {
    return {
      dateStart: this.match.date_start,
      dateEnd: this.match.date_end,
      duration: this.match.date_end - this.match.date_start,
    };
  },
  computed: {
    initialDuration() {
      return this.match.date_end - this.match.date_start;
    },
  },
  watch: {
    dateStart(newVal) {
      this.dateEnd = newVal + Math.max(this.initialDuration, this.duration);
    },
    dateEnd() {
      this.updateDuration();
    },
  },
  methods: {
    ...mapActions(['closeModal', 'errorNotify', 'updateMatchAction']),
    updateDuration() {
      this.duration = this.dateEnd - this.dateStart;
    },
    onSave() {
      this.setLoading();
      const roundID = this.match.round || 0;
      const data = {
        date_start: this.dateStart,
        date_end: this.dateEnd,
      };

      this.updateMatchAction({
        roundID,
        matchID: this.match.id,
        data,
      })
        .then(() => {
          this.$emit('save', data);
          this.closeModal();
        })
        .catch(this.errorNotify)
        .finally(this.unsetLoading);
    },
  },
};
</script>
<style lang="scss">
.match-scheduling-modal {
  max-height: 100vh;
  max-width: 22rem;
  width: 100%;
}
</style>
